export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00825.9157b5a3.png";